import styled from 'styled-components';

export default styled.div`
  padding: 0.5rem 0;
`;
